














import Vue from 'vue';

// Services
import AonContext, { InstrumentStatus } from '~/services/AonContext';

// Assets
import DeloittePng from '~/assets/img/aon/deloitte.png';
import SiemensPng from '~/assets/img/aon/siemens.png';
import BurgerKingPng from '~/assets/img/aon/burgerking.png';
import VodafonePng from '~/assets/img/aon/vodafone.png';
import PNGPng from '~/assets/img/aon/png.png';

export default Vue.extend({
    name: 'AssessmentSection4',
    props: {
        context: {
            type: Object as () => AonContext,
            default: () => ({} as AonContext),
        },
    },
    data: () => ({
        logos: [DeloittePng, SiemensPng, BurgerKingPng, VodafonePng, PNGPng],
    }),
    computed: {
        hasStartedAssessments(): Boolean {
            if (!this.context) {
                return false;
            }

            return (
                this.context.freemiumStatus > InstrumentStatus.UNKNOWN ||
                this.context.premiumStatus > InstrumentStatus.UNKNOWN
            );
        },
    },
});
